module.exports = __webpack_public_path__ + "img/medio3.64f6825f.jpg";